import React from 'react';
import styles from '../styles/cruizPage.module.sass';

export const faqItems = [
  {
    title: 'Что включено и не включено в стоимость круиза',
    body: (
      <div className={styles.listFull}>
        В стоимость обычно включается: размещение в каюте выбранной категории,
        питание на борту — завтрак, обед, ланч, ужин, поздний ужин, все
        развлекательные программы на борту, пользование спортивным
        оборудованием, бассейнами, а также плавсредствами для посадки и высадки
        в портах, где корабль не причаливает к пристани. Дополнительно
        оплачиваются портовые и топливные сборы (как правило, при бронировании),
        пакеты напитков, услуги массажа, стирка и глажка одежды, процедуры в
        спа-центрах и т.п.), экскурсии и чаевые. При оформлении круизного тура
        всегда следует уделять особое внимание дополнительным услугам, которые
        чаще всего не входят в стоимость основной программы: авиабилетам,
        медицинской страховке, трансферам и визам.
      </div>
    ),
  },
  {
    title: ' На какую дату бронировать перелет в город отправления круиза?',
    body: (
      <div className={styles.listFull}>
        Рекомендуем выбирать рейс, прилетающий за день до начала круиза: так вы
        сможете избежать опоздания на круиз в случае задержки рейса. А также
        нужно потратить время на дорогу от аэропорта до морского порта. Корабль
        не будет дожидаться опоздавших. А догонять лайнер придется в других
        городах, потратив на это много нервов, времени и средств.
      </div>
    ),
  },
  {
    title: 'Какие документы нужны для круиза и во время круиза?',
    body: (
      <div className={styles.listFull}>
        Для круиза Вам необходимо иметь документы на все забронированные и
        оплаченные услуги. Это: <li>авиабилет,</li>{' '}
        <li>
          ваучер на круиз с указанием корабля, даты начала и даты окончания
          маршрута, номера каюты и описанием маршрута,
        </li>{' '}
        <li>медицинский страховой полис,</li> <li>ваучер на трансфер,</li>
        <li>виза (при необходимости),</li>{' '}
        <li>ваучер на проживание до и (или) после круиза.</li>
      </div>
    ),
  },
  {
    title: 'Что взять с собой?',
    body: (
      <div className={styles.listFull}>
        <li>Фотоаппарат</li> <li>Солнечные очки</li>
        <li>Крем от солнечных лучей</li> <li>Удобная обувь для экскурсий</li>
        <li>Сланцы (для пляжа/ бассейна)</li>
        <li>Зимняя одежда (для северных кризов)</li>{' '}
        <li>Легкая теплая одежда</li>
        <li>Плащ / зонт</li>{' '}
        <li>
          Одежда для ужина в стиле Casual (футболки, джинсы, шорты, рубашки с
          воротником, и т.д.)
        </li>{' '}
        <li>
          Вечерняя одежда (для ужинов с капитаном / коктейльных вечеринок)
        </li>{' '}
        <li> Купальник</li> <li>Туалетные принадлежности</li>
        <li>Аптечка</li>
        <li>Банковские карты</li>
        <li>Наличные деньги</li>
        <li>Заграничный паспорт</li>
        <li>
          Водительские права международного образца (если Вы планируете брать
          машину на прокат)
        </li>{' '}
        <li>Билеты\ваучеры\путевки</li>
      </div>
    ),
  },
  {
    title: 'Посадка на лайнер',
    body: (
      <div className={styles.listFull}>
        По прибытии в порт посадки следуйте указателям с надписью нужного
        корабля. Регистрация на корабль, обычно, начинается за 3-4 часа и
        заканчивается за 1,5-2 часа до отплытия. До посадки на корабль туристам
        нужно:{' '}
        <li>
          наклеить на багаж специальные бирки, которые выдаются при регистрации
          на лайнер. На бирках нужно указать латинскими буквами имя, фамилию,
          название корабля, номер каюты, дату и порт отправления;
        </li>{' '}
        <li>
          сдать багаж с наклеенными бирками носильщикам, которые доставят его к
          дверям каюты ( в течение часа после отплытия);
        </li>{' '}
        <li>
          подойти к стойке регистрации и предъявить паспорт и билет на круиз;
        </li>{' '}
        <li>
          после проверки документов пассажирам выдается магнитная карта, которая
          в дальнейшем используется как ключ от каюты, пропуск на корабль и
          карта для оплаты услуг.
        </li>
      </div>
    ),
  },
  {
    title: ' Опоздание на регистрацию',
    body: (
      <div className={styles.listFull}>
        Если туристы опоздали на регистрацию на лайнер, то они должны в срочном
        порядке информировать о данном инциденте генерального представителя или
        свое агентство, указав, в каком из портов по маршруту они присоединятся
        к круизу. Все расходы, связанные с транспортировкой опоздавших
        пассажиров берут на себя сами опоздавшие пассажиры. Если турист не
        информирует об опоздании – его каюта будет аннулирована, штраф по
        аннуляции составит 100%
      </div>
    ),
  },
  {
    title: 'Как производятся расчеты на борту?',
    body: (
      <div className={styles.listFull}>
        На борту всех кораблей действует система безналичного расчета: для
        оплаты всех расходов туристы используют круизную карту. По окончании
        круиза потраченную сумму списывают с кредитной карты или с депозита,
        которые привязываются к круизной карте в начале путешествия.
      </div>
    ),
  },
  {
    title: 'Стиль одежды на борту',
    body: (
      <div className={styles.listFull}>
        В большинстве случаев вполне подходящей является комфортная повседневная
        одежда. Более нарядный вариант приветствуется при посещении ресторанов.
        На гала-ужины мужчинам рекомендуется приходить в костюме и галстуке, а
        женщинам – в вечернем платье. В случае необходимости костюм или смокинг
        можно взять напрокат. В ресторанах не приветствуются футболки, рваные
        джинсы, шорты, спортивная одежда и т.п. Для посещения береговых
        экскурсий подойдет удобная одежда и обувь. Для посещения бассейнов,
        джакузи, аквапарков не стоит забывать об одежде для плавания.
      </div>
    ),
  },
  {
    title: 'Организация питания',
    body: (
      <div className={styles.listFull}>
        На круизных лайнерах в большинстве случаев питание представляет собой
        полный пансион и входит в стоимость тура. Типичное расписание питания на
        борту выглядит примерно следующим образом:{' '}
        <li>
          06:00 горячий чай и кофе на палубе для любителей раннего подъема.
        </li>{' '}
        <li>
          Завтрак. Обычно в ресторане предлагают различные варианты типичных для
          завтрака блюд. В качестве альтернативы, можно позавтракать на
          «шведском столе» или в кафе на открытом воздухе.
        </li>{' '}
        <li>
          Обед в основном ресторане, в ресторане со «шведским столом», либо в
          кафе.
        </li>{' '}
        <li>16:00 чай с бутербродами и пирожными.</li>{' '}
        <li>
          Ужин – основное событие вечера, и обычно, за исключением первого
          вечера после посадки, он предполагает более формальный стиль одежды.
        </li>{' '}
        <li>Полночный буфет</li>
        На многих современных лайнерах, помимо основного питания предусмотрены
        круглосуточные кафе, где можно перекусить в любое время. Кроме того на
        многих кораблях есть альтернативные рестораны, где за дополнительную
        плату можно забронировать себе столик и насладиться шедеврами
        кулинарного искусства и великолепным сервисом в романтической атмосфере.
        Также при желании туристы могут заказать себе при бронировании круиза
        специальное диетическое питание.
      </div>
    ),
  },
  {
    title: 'Развлечения на борту',
    body: (
      <div className={styles.listFull}>
        Спектр развлечений во время круиза весьма широк и разнообразен. Он
        тщательно разрабатывается с учетом того, что на борту лайнера
        путешествуют пассажиры разных национальностей и разных вкусов. Туристы
        всегда смогут найти мероприятие, которое будет им интересно: ежевечернее
        шоу (концерты, мюзиклы и т.п.), дискотека, концерты живой музыки в
        разных холлах, конкурсы и соревнования. В течение дня в разных холлах на
        открытой палубе команда аниматоров организовывает различные активности.
        На борту многих лайнеров работает казино. Помимо всего, у отдыхающих
        есть возможность воспользоваться услугами фитнесс-центра: спортзал,
        беговая дорожка, сауна, джакузи, бассейн и т.д. (набор таких услуг может
        варьироваться на разных лайнерах). На некоторых лайнерах есть даже
        каток, стена для занятий скалолазанием, бассейн для серфинга. На
        современных кораблях оборудованы SPA-центры, в которых предлагают массу
        оздоровительных процедур (за дополнительную плату). Для детей существует
        также много развлечений: так, под наблюдением специальной анимационной
        команды, они могут провести время в группе, соответствующей их возрасту,
        провести время в детской библиотеке или детской комнате.
      </div>
    ),
  },
  {
    title: 'Услуги на борту',
    body: (
      <div className={styles.listFull}>
        Интернет. Все современные лайнеры предлагают услуги Интернет-кафе на
        борту. На многих лайнерах оборудовано подключение к Интернету в каюте, а
        современные корабли предлагают услугу беспроводного Интернета. Эта
        услуга платная.
        <br />
        Услуги прачечной. Практически на всех лайнерах предлагаются услуги
        стирки и глажения вещей, а также химчистки. Подробный перечень и
        прейскурант можно будет найти в каюте.
        <br />
        Медицинские услуги. Практически все лайнеры предлагают квалифицированную
        медицинскую помощь. На борту каждого корабля есть медцентр,
        предназначенный для решения экстренных или несложных медицинских
        проблем. Бортовой врач обычно берет плату за свои услуги. В момент
        бронирования каюты турист обязан сообщить о любых существенных проблемах
        со здоровьем, требующих особого медицинского ухода.
        <br />
        Телекоммуникация на борту. Наличие на кораблях спутниковой связи
        позволяет туристам беспрепятственно делать звонки.
        <br />
        Сейф. Бесплатный сейф есть в некоторых каютах и на стойке регистрации.
        <br />
      </div>
    ),
  },
  {
    title: 'Высадка на берег в портах захода',
    body: (
      <div className={styles.listFull}>
        По прибытии в порт представители местных властей проводят
        документационную инспекцию лайнера, по окончании которой пассажиров
        приглашают пройти к трапам. Сначала на берег выходят участники береговых
        экскурсий, затем – пассажиры, которые выходят самостоятельно. Выход и
        вход на лайнер происходят по бортовым пластиковым картам, которые
        необходимо предъявлять для проверки службе безопасности. Пассажиры могут
        свободно выходить на берег в любое время и аналогичным образом
        возвращаться на борт лайнера. Но следует помнить, что все пассажиры
        должны вернуться на борт лайнера не позднее чем за 60 минут до отплытия.
        Лайнер опоздавших не ждет, и догонять его придется за свой счет. В самом
        экстренном случае, если туристы все-таки по какой-то причине опоздали,
        им необходимо связаться с портовым агентом (координаты портового агента
        всегда указаны в ежедневных программах), который поможет им организовать
        необходимое размещение и транспортировку.
      </div>
    ),
  },
];
